






































































































































































































































































































    import { Component, RightHelper } from "../../../Infrastructure/CorBase/CoreBase";
	import TenantDetailBase from "./TenantDetailBase";

	@Component
	export default class TenantDetail extends TenantDetailBase {
	
		created() {
			super.initializeRights('COR_Tenant_Create', 'COR_Tenant_Delete', 'COR_Tenant_Read', 'COR_Tenant_Update');
			super.setMainDescription('tenant.new', 'tenant.detail');
		}

        dynamicID() {
            var id = 'dynamicID-' + (Math.floor(Math.random() * Date.now()));
            return id;
        }

		goToTest() {
            this.$router.push({ name:"TestDetail" });
		}

		confirmDeleteClick() {
            this.showAlertModalById("alertModalIdToConfirmDelete");
		}

		deleteClick() {
            this.deleteBase();
		}


		showTableModul() {
            return RightHelper.currentUserHasRight('COR_Tenant_Read') && this.styleFormNew==false;
		}
		//a

        saveChangeLanguageTenant() {
            this.saveChangeLanguageTenantBase();
        }

        goBackLanguageTenant() {
            this.goBackLanguageTenantBase();
        }

        deleteLanguageTenant(item: any) {
            this.deleteLanguageTenantBase(item);
        }

        addNewLanguageTenant() {
            this.addNewLanguageTenantBase();
        }

        selectedLanguageTenantItems(selected: any): void {
            this.selectedLanguageTenantItemsBase(selected);
        }

		//b
        isEditableTableModul() {
            return RightHelper.currentUserHasRight('COR_Tenant_Update');
        }

		saveChangeModul() {
			this.saveChangeModulBase();
		}

		goBackModul() {
			this.goBackModulBase();
		}

		deleteModul(item: any) {
			this.deleteModulBase(item);
		}

		addNewModul() {
			this.addNewModulBase();
		}

        selectedModulItems(selected: any): void {
            this.selectedModulItemsBase(selected);
        }

		disableAddButton() {
			return false;
		}

		selectRows() {

		}

		modulNotChanged() {
			return true;
		}

		questionText() {
            return this.formData.isLock ? this.$t("tenant.messageQuestionUnlockTenant") : this.$t("tenant.messageQuestionLockTenant");
		}

		showLockTenant() {
            this.showAlertModalById("alertModalIdBlock");
		}

		lockUnlockTenant() {
			if (this.formData.isLock) {
                this.unlockTenantBase();
			}
			else {
                this.lockTenantBase();
			}
		}

		showSaveAll() {
			return this.showSaveAllBase;
		}

		preventRefresh(event: any) {
            if (this.$store.state.askBeforeCancelEditing === true && this.formIsInEditMode && this.dataWasChanged()) {
                event.preventDefault(); event.returnValue = "";
            }
        }

        beforeMount() {
            window.addEventListener("beforeunload", this.preventRefresh);
        }

        beforeDestroy() {
            window.removeEventListener("beforeunload", this.preventRefresh);
            this.$store.commit("formIsInEditMode", false);
        }

		///hlaska o prekroceni inputu po Ctrl+V
		protected infoShortInput(maxLength: string): void {
			this.infoShortInputBase(maxLength);
		}		

        isCorrectIdentif(value: any) {
            this.isCorrectIdentifBase(value);
		}

        isCorrectShotname(value: any) {
            this.isCorrectShotnameBase(value);
        }

        isCorrectName(value: any) {
            this.isCorrectNameBase(value);
		}
      
        isCorrectPass(value: any) {
            this.isCorrectPassBase(value);
        }

        isCorrectPassAgain(value: any) {
            this.isCorrectPassAgainBase(value);
		}

        isCorrectEmail(value: any) {
            this.isCorrectEmailBase(value);
		}


		mounted() {
			super.mounted();
		};

		resendEmailRegistration() {
			this.resendEmailRegistrationBase();
		}

        confirmRegistrationTenant() {
            this.confirmRegistrationTenantBase();
        }
	
	}
